"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = require("../component");

var _Header = _interopRequireDefault(require("./Header"));

var _Wrapper = _interopRequireDefault(require("./Wrapper"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Tabs =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Tabs, _PureComponent);

  function Tabs(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      active: props.defaultActive || 0,
      collapsed: props.defaultCollapsed
    };
    _this.getAlign = _this.getAlign.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleCollapse = _this.handleCollapse.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.renderContent = _this.renderContent.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Tabs.prototype;

  _proto.getAlign = function getAlign() {
    var _this$props = this.props,
        shape = _this$props.shape,
        collapsible = _this$props.collapsible,
        align = _this$props.align;
    var isVertical = align && align.indexOf('vertical') > -1;

    if (shape === 'button' && isVertical) {
      console.warn("align vertical-* can't supported when shape is button");
      return {
        align: 'left',
        isVertical: false
      };
    }

    if (collapsible && isVertical) {
      console.warn("align vertical-* can't supported when collapsible is true");
      return {
        align: 'left',
        isVertical: false
      };
    }

    return {
      align: align,
      isVertical: isVertical
    };
  };

  _proto.getActive = function getActive() {
    if (this.props.active) return this.props.active;
    return this.state.active;
  };

  _proto.handleChange = function handleChange(active) {
    var onChange = this.props.onChange;
    if (onChange) onChange(active);
    this.setState({
      active: active
    });
  };

  _proto.handleCollapse = function handleCollapse(collapsed) {
    this.setState({
      collapsed: collapsed
    });
  };

  _proto.renderHeader = function renderHeader(_ref) {
    var _this2 = this;

    var align = _ref.align,
        isVertical = _ref.isVertical;
    var _this$props2 = this.props,
        children = _this$props2.children,
        color = _this$props2.color,
        shape = _this$props2.shape,
        tabBarStyle = _this$props2.tabBarStyle,
        inactiveBackground = _this$props2.inactiveBackground,
        collapsible = _this$props2.collapsible,
        tabBarExtraContent = _this$props2.tabBarExtraContent;
    var active = this.getActive();
    var tabs = [];
    var border = this.props.border;

    _react.Children.toArray(children).forEach(function (child, i) {
      if (!child || !child.type) return;
      var tab = null;

      if (child.type.isTabPanel) {
        // eslint-disable-next-line
        tab = child.props.tab;
      } else if (child.type.isTabLink) {
        tab = child;
      } else return;

      var _child$props = child.props,
          _child$props$id = _child$props.id,
          id = _child$props$id === void 0 ? i : _child$props$id,
          background = _child$props.background;
      var childBorder = child.props.border; // eslint-disable-next-line

      if (active === id) {
        if (childBorder) border = childBorder;else childBorder = border;
      }

      tabs.push({
        id: id,
        isActive: active === id,
        tab: tab,
        isVertical: isVertical,
        align: align,
        background: background || (active === id ? _this2.props.background : inactiveBackground),
        border: childBorder,
        color: child.props.color || (active === id ? color : undefined),
        disabled: child.props.disabled,
        shape: shape
      });
    });

    return _react.default.createElement(_Header.default, {
      isVertical: isVertical,
      border: border,
      collapsed: this.state.collapsed,
      onCollapse: collapsible ? this.handleCollapse : undefined,
      shape: shape,
      onChange: this.handleChange,
      tabs: tabs,
      tabBarExtraContent: tabBarExtraContent,
      tabBarStyle: tabBarStyle
    });
  };

  _proto.renderContent = function renderContent(child, i) {
    if (!(child && child.type && child.type.isTabPanel)) return null;
    var collapsible = this.props.collapsible;

    var _child$props2 = child.props,
        _child$props2$id = _child$props2.id,
        id = _child$props2$id === void 0 ? i : _child$props2$id,
        other = _objectWithoutPropertiesLoose(_child$props2, ["id"]);

    return _react.default.createElement(_Wrapper.default, _extends({}, other, {
      collapsed: this.state.collapsed,
      collapsible: collapsible,
      id: id,
      key: id,
      active: this.getActive()
    }));
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        children = _this$props3.children,
        shape = _this$props3.shape,
        style = _this$props3.style;
    var position = this.getAlign();
    var align = position.align,
        isVertical = position.isVertical;
    var className = (0, _classnames.default)((0, _styles.tabsClass)('_', align && "align-" + align, isVertical && 'vertical', shape), this.props.className);
    return _react.default.createElement("div", {
      className: className,
      style: style
    }, align !== 'vertical-right' && align !== 'bottom' && this.renderHeader(position), _react.Children.toArray(children).map(this.renderContent), (align === 'vertical-right' || align === 'bottom') && this.renderHeader(position));
  };

  return Tabs;
}(_component.PureComponent);

Tabs.propTypes = {
  active: _propTypes.default.any,
  align: _propTypes.default.oneOf(['left', 'right', 'vertical-left', 'vertical-right', 'bottom']),
  background: _propTypes.default.string,
  border: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.array]),
  className: _propTypes.default.string,
  collapsible: _propTypes.default.bool,
  color: _propTypes.default.string,
  defaultActive: _propTypes.default.any,
  defaultCollapsed: _propTypes.default.bool,
  inactiveBackground: _propTypes.default.string,
  onChange: _propTypes.default.func,
  shape: _propTypes.default.oneOf(['card', 'line', 'button']),
  style: _propTypes.default.object,
  tabBarExtraContent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  tabBarStyle: _propTypes.default.object
};
Tabs.defaultProps = {
  background: '#fff',
  border: '#ddd',
  color: '#333',
  defaultCollapsed: false,
  inactiveBackground: 'transparent'
};
var _default = Tabs;
exports.default = _default;